<button class="container--button {{ selected ? 'selected' : '' }}" (click)="active()">
    <p class="value {{ color }}">{{ value }}</p>
    <p class="label {{ color }}">{{ label }}</p>
</button>